import { Col, Form, Modal, Row, Skeleton, Space } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import AtomPrimaryButton from "../../button/primary-button";
import AtomSecondaryButton from "../../button/secondary-button";
import AtomUploadImage from "../../input/upload-image";
import InputText from "../../input/input-text";

const ProfileModal = ({
  title,
  loading,
  userDetail,
  open,
  setOpen,
  profileImage,
  setProfileImage,
  isSubmit,
  onFinish,
}) => {
  const [form] = Form.useForm();

  const firstName = Form.useWatch("firstName", form);
  const lastName = Form.useWatch("lastName", form);

  const [previewUrl, setPreviewUrl] = useState(
    userDetail?.profile_image_link ?? ""
  );

  const onSubmit = async (values) => {
    await onFinish(values);
  };

  return (
    <Modal
      title={title}
      centered
      open={open.visible}
      onCancel={() => {
        setOpen({ visible: false });
      }}
      footer={null}
    >
      {loading ? (
        <Skeleton active />
      ) : (
        <Form
          form={form}
          name="profile"
          layout="vertical"
          initialValues={{
            firstName: userDetail?.first_name || "",
            lastName: userDetail?.last_name || "",
          }}
          onFinish={onSubmit}
          autoComplete="off"
        >
          <Row gutter={[16, 16]}>
            <Col span={7}>
              <AtomUploadImage
                image={profileImage}
                setImage={setProfileImage}
                previewUrl={previewUrl}
                isEdit={open.id || userDetail}
              />
            </Col>

            <Col span={17}></Col>

            <Col span={12}>
              <InputText
                label="First Name"
                name="firstName"
                placeholder="first name"
                message="first name"
              />
            </Col>

            <Col span={12}>
              <InputText
                label="Last Name"
                name="lastName"
                placeholder="last name"
                message="last name"
              />
            </Col>
          </Row>

          <Row justify="center">
            <Space size="middle">
              <AtomPrimaryButton
                disabled={!previewUrl || !firstName || !lastName}
                loading={isSubmit}
                htmlType="submit"
              >
                Save
              </AtomPrimaryButton>

              <AtomSecondaryButton
                onClick={() => {
                  setOpen({ visible: false });
                }}
              >
                Cancel
              </AtomSecondaryButton>
            </Space>
          </Row>
        </Form>
      )}
    </Modal>
  );
};

export default ProfileModal;
